import React, { useEffect } from "react";
import PropTypes from "prop-types";

// context
import { useDevices } from "./useDevices";

// helpers
import { isIosCheck } from "frontend/utils/index.js";

// component
const MountingWrapper = ({ children }) => {
    const { setIsIOS } = useDevices();

    useEffect(() => {
        setIsIOS(isIosCheck());
    }, []);

    return <>{children}</>;
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
